import { call, put, select, takeLatest } from 'redux-saga/effects';

import paymentService from 'services/paymentService';

import { getGroupId } from 'store/session/selectors';

import { types, downloadChargeReceipts } from './actions';

export default function* root() {
  yield takeLatest(
    types.DOWNLOAD_CHARGE_RECEIPTS_REQUEST,
    watchDownloadChargeReceipts,
  );
}

function* watchDownloadChargeReceipts() {
  try {
    const groupId = yield select(getGroupId);
    yield call(paymentService.downloadChargeReceiptsCsv, groupId);
    yield put(downloadChargeReceipts.success());
  } catch (err) {
    yield put(
      downloadChargeReceipts.error(
        err.statusCode === 404
          ? new Error('Account does not have any charges')
          : err,
      ),
    );
  }
}
